import { Card, CardProps } from 'antd';
import styles from './index.module.scss';

export const CommonCard = (props: CardProps) => {
  return (
    <Card {...props} className={`${styles.card} ${props.className || ''}`}>
      {props.children}
    </Card>
  );
};
